import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Paper,
    styled,
    Box,
    CircularProgress
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableHead = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#00a62b",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const TablaCierreMensual = ({ loading, data, orderBy, orderDirection, handleSort }) => {
    return (
        <div className="main">
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper sx={{ width: "100%", overflow: "hidden", marginBottom: "2rem" }}>
                    <TableContainer sx={{ maxHeight: 600, overflowX: 'auto', width: '100%' }}>
                        <Table stickyHeader size="small" aria-label="lista cierres mensuales" sx={{ minWidth: 1200, whiteSpace: 'nowrap' }}>
                            <TableHead>
                                <TableRow>
                                    {[
                                        { id: 'nombreBroker', label: 'Broker' },
                                        { id: 'correo', label: 'Correo' },
                                        { id: 'ingresoMes', label: 'Ingreso' },
                                        { id: 'ingresoTrimestral', label: 'Ingreso Trimestral' },
                                        { id: 'ingresoAnual', label: 'Ingreso Anual' },
                                        { id: 'metaTrimestral', label: 'Meta Trimestral' },
                                        { id: 'metaAnual', label: 'Meta Anual' },
                                        { id: 'nCierresMensual', label: 'N° Cierres Mensual' },
                                        { id: 'nCierresAnual', label: 'N° Cierres Anual' },
                                        { id: 'visualizacionesPropiedades', label: 'Vis. Propiedades' },
                                        { id: 'nStocks', label: 'N° Stocks' },
                                        { id: 'mes', label: 'Mes' },
                                        { id: 'versionMes', label: 'Versión' },
                                    ].map((headCell) => (
                                        <StyledTableHead key={headCell.id} sx={{ fontWeight: "bold" }}>
                                            <TableSortLabel
                                                active={orderBy === headCell.id}
                                                direction={orderBy === headCell.id ? orderDirection : 'asc'}
                                                onClick={() => handleSort(headCell.id)}
                                                sx={{
                                                    '&.MuiTableSortLabel-root': { color: 'white' },
                                                    '&.MuiTableSortLabel-active': { color: 'white' },
                                                    '& .MuiTableSortLabel-icon': { color: 'white !important' }
                                                }}
                                            >
                                                {headCell.label}
                                            </TableSortLabel>
                                        </StyledTableHead>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.length > 0 ? (
                                    data.map((row, index) => (
                                        <TableRow key={index} hover className={index % 2 === 0 ? "filaOscura" : ""}>
                                            <TableCell>{row.nombre_Broker || row.nombreBroker || "-"}</TableCell>
                                            <TableCell>{row.Correo || row.correo || "-"}</TableCell>
                                            <TableCell>{row.ingreso_Mes || row.ingresoMes || 0}</TableCell>
                                            <TableCell>{row.ingreso_Trimestral || row.ingresoTrimestral || 0}</TableCell>
                                            <TableCell>{row.ingreso_Anual || row.ingresoAnual || 0}</TableCell>
                                            <TableCell>{row.meta_Trimestral || row.metaTrimestral || 0}</TableCell>
                                            <TableCell>{row.meta_Anual || row.metaAnual || 0}</TableCell>
                                            <TableCell>{row.n_Cierres_Mensual || row.nCierresMensual || 0}</TableCell>
                                            <TableCell>{row.n_Cierres_Anual || row.nCierresAnual || 0}</TableCell>
                                            <TableCell>{row.visualizaciones_Propiedades || row.visualizacionesPropiedades || 0}</TableCell>
                                            <TableCell>{row.n_Stocks || row.nStocks || 0}</TableCell>
                                            <TableCell>{row.mes || "-"}</TableCell>
                                            <TableCell>{row.version || row.versionMes || "-"}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={13} align="center" sx={{ py: 3 }}>
                                            <div>No hay registros de cierre mensual disponibles.</div>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            )}
        </div>
    );
};

export default TablaCierreMensual;
